import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";
import { alignVariants } from "../../utils/vanilla/alignVariants";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    display: "inline-flex",
    borderRadius: theme.borderRadiuses.onS,
    background: theme.colors.tertiary,
    overflow: "hidden",
    border: `1px solid ${theme.colors.defaultBorder}`,
    transition: transition("border-color", "box-shadow", "opacity"),
    boxShadow: "0 0 0 0 transparent",
    selectors: {
      "&[aria-disabled]": {
        ...disabledState,
      },
    },
  },
  variants: {
    size: {
      default: {
        gap: rem(2),
        padding: rem(3),
      },
    },
    error: {
      true: {
        vars: {
          "border-color": theme.colors.error,
        },
      },
    },
    alignSelf: alignVariants("alignSelf"),
  },
  defaultVariants: {
    size: "default",
  },
});

export const buttonStyle = recipe({
  base: {
    color: theme.colors.onBackground,
    userSelect: "none",
    position: "relative",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    transition: transition(
      "color",
      "outline",
      "background-color",
      "opacity",
      "border-color",
      {
        property: "transform",
        duration: theme.transition.duration.xs,
      },
    ),
    vars: {
      "--border-color": theme.colors.secondary,
    },
    selectors: {
      "&:hover, &[data-active]": {
        zIndex: 2,
      },
      "&:not([disabled])": {
        cursor: "pointer",
      },
      "&[disabled]": {
        // cursor: "not-allowed",
      },
    },
  },
  variants: {
    active: {
      true: {
        color: `${theme.colors.primary} !important`,
      },
    },
    size: {
      default: {
        borderRadius: `calc(${theme.borderRadiuses.s})`,
        paddingLeft: rem(16),
        paddingRight: rem(16),
        height: rem(40),
        gap: rem(8),
      },
    },
    variant: {
      default: {
        color: theme.colors.onBackground,
        selectors: {
          "&:not(.--touch):not([disabled]):hover, &:not(.--touch):not([disabled])[data-active]":
            {
              backgroundColor: theme.colors.background,
              color: theme.colors.onBackground,
            },
        },
      },
    },
  },
  defaultVariants: {
    size: "default",
    variant: "default",
  },
});
